import { gradesMapper } from "./gradesMapper"

export function unitsMapper(data) {
  return {
    grades: gradesMapper(data?.grades),
    units:
      data?.units && data.units.length > 0
        ? data.units.map((unit) => ({
            name: unit.unit_name
              ? unit.unit_name.charAt(0).toUpperCase() + unit.unit_name.slice(1)
              : "",
            parsedName: unit.unit_parsed_name,
            subunits:
              unit.values && unit.values.length > 0
                ? unit.values.map((subunit) => ({
                    subunitId: subunit.unit_id,
                    gradeId: subunit.grade_id,
                  }))
                : [],
          }))
        : [],
  }
}

export function subunitsMapper(units) {
  return units && units.length > 0
    ? units.map((unit) => ({
        id: unit._id,
        name: unit.name
          ? unit.name.charAt(0).toUpperCase() + unit.name.slice(1)
          : "",
        grade: {
          name: unit.grade?.name,
          order: unit.grade?.order,
        },
        parsedName: unit.parsed_name,
        keyWords:
          unit.key_words && unit.key_words.length > 0
            ? unit.key_words.map((word) => ({
                word: word.name,
                parsedWord: word.parsed_name,
                definition: word.definition,
                sentence: word.sentence,
                sessionGroup: word.key_word_session,
                exerciseType: word.exercise_type,
                options: word.options,
                correct: word.correct,
              }))
            : [],
      }))
    : []
}

export function grammarSessionsMapper(sessions, automated = false) {
  return !automated
    ? assignedGrammarSessionsMapper(sessions)
    : automatedGrammarSessionsMapper(sessions)
}

function assignedGrammarSessionsMapper(cards) {
  return cards.map((card) => {
    let date = card.event.date
    let students = {}
    card.data.forEach((data) => {
      data.lessons.forEach((lesson) => {
        let newLessonData = {}
        newLessonData[data.session_number] = {
          studentId: lesson.student_id,
          studentName:
            lesson.firstname + (lesson.lastname ? " " + lesson.lastname : ""),
          lessonId: lesson._id,
          lessonGroupToken: lesson.lesson_group_token,
          eventId: card.event.event_id,
          sessionNumber: data.session_number,
          student: { id: lesson.student_id },
        }
        let newStudent = {}
        newStudent[lesson.student_id] = {
          ...students[lesson.student_id],
          ...newLessonData,
        }
        students = { ...students, ...newStudent }
      })
    })
    let parsedStudents = (Object.keys(students) || []).map((studentId) =>
      Object.keys(students[studentId]).map(
        (sessionNumber) => students[studentId][sessionNumber]
      )
    )
    return {
      date,
      subunit: {
        id: card.subunit.subunit__id,
        name: card.subunit.subunit_name,
        parsedName: card.subunit.subunit_parsed_name,
      },
      eventId: card.event.event_id,
      deadline: card.event.deadline,
      assignedBy: card.event?.assigned_by?.firstname
        ? card.event?.assigned_by.firstname +
          (card.event?.assigned_by.lastname
            ? " " + card.event?.assigned_by.lastname
            : "")
        : "",
      students,
      parsedStudents,
      events: card.data.map((event) => ({
        sessionNumber: event.session_number,
        lessonWords: event.lesson_data.key_words.map((w) => {
          if (w.exercise_type === "blank") {
            return w.options[w.correct].option.toLowerCase()
          } else {
            return w.name
          }
        }),
      })),
    }
  })
}

function automatedGrammarSessionsMapper(cards) {
  return cards
    .map((card) => {
      let date = card.date
      return Object.keys(card.events).map((subunitName) => {
        let events = card.events[subunitName]
        return {
          date,
          subunit: {
            id: events[0].lessons[0].subunit?._id,
            name: events[0].lessons[0].subunit?.name,
            parsedName: events[0].lessons[0].subunit?.parsed_name,
          },
          sessionNumber: events[0].grammar_session_number,
          events: events.map((event) => ({
            eventId: event?._id,
            lessonId: event.lessons[0]?._id,
            lessonWords: event.lessons[0]?.key_words.map((w) => {
              if (w.exercise_type === "blank") {
                return w.options[w.correct].option.toLowerCase()
              } else {
                return w.name
              }
            }),
            lessonGroupToken: event.lessons[0]?.group_token,
            lessonCompletedAt: event.lessons[0]?.session_completed_at,
            student: {
              id: event.lessons[0]?.student?._id,
              name:
                event.lessons[0]?.student?.firstname +
                (event.lessons[0]?.student?.lastname
                  ? " " + event.lessons[0]?.student?.lastname
                  : ""),
              firstname: event.lessons[0]?.student?.firstname,
              lastname: event.lessons[0]?.student?.lastname,
            },
          })),
        }
      })
    })
    .flat(1)
}

export function basicScoreMapper(score) {
  return {
    lessonId: score?.grammar_lesson_id,
    sessionCompleted: score?.session_completed,
    accuracyRate: score?.tot_accuracy_rate,
  }
}

export function wordImgMapper(imgs) {
  return imgs[0]?.url
}

export function audioMapper(audio) {
  return audio?.audio
}

export function lessonMapper(lesson) {
  // este filtro se hace por si llega alguna lesson de blank con mas de una vez la misma opcion correcta
  const getFilteredWords = (keywords) => {
    // si no tiene ejercicios blank, no hace falta filtrar keywords
    if (!keywords.some((keyword) => keyword.exercise_type === "blank"))
      return keywords
    const uniqueOptions = {}
    const filteredWords = keywords.filter((keyword) => {
      const correctOption = keyword.options[keyword.correct]
      const parsedOptionName = correctOption.option.toLowerCase()
      if (!uniqueOptions[parsedOptionName]) {
        const optionToShow = { ...correctOption, option: parsedOptionName }
        uniqueOptions[parsedOptionName] = optionToShow
        return true
      }
      return false
    })
    return filteredWords
  }
  const filteredWords = getFilteredWords(lesson.key_words)
  return {
    subunit: {
      name: lesson.subunit_name,
      parsedName: lesson.subunit_parsed_name,
    },
    words: filteredWords.map((word) => ({
      word: word.name
        ? word.name.charAt(0).toUpperCase() + word.name.slice(1)
        : "",
      description: word.definition
        ? word.definition.replace(/(?<=(?:^|[.?!])\W*)[a-z]/g, (i) =>
            i.toUpperCase()
          )
        : "",
      sentence: word.sentence
        ? word.sentence.replace(/(?<=(?:^|[.?!])\W*)[a-z]/g, (i) =>
            i.toUpperCase()
          )
        : "",
      parsedName: word.parsed_name,
      options: word.options,
      correct: word.correct,
      exerciseType: word.exercise_type,
    })),
    lessonData: lesson.lesson_data,
    lessonVerb: lesson.lesson_verb,
  }
}

export function pendingFutureSessionMapper(session) {
  return session
    ? {
        subunitName: session.subunit?.name,
        subunitParsedName: session.subunit?.parsed_name,
        sessionNumber: session.session_number,
      }
    : undefined
}

export function timelineAssignedMapper(events) {
  return events && events.length > 0
    ? events.map((event) => ({
        subunitName: event.grammar_subunit?.name,
        isAllSubunit: event.grammar_is_all_subunit,
        sessionsPending:
          (event.grammar_subunit?.tot_sessions || 0) -
          (event.lessons?.length || 0),
        deadline: event.deadline,
        lessons:
          event.lessons && event.lessons.length > 0
            ? event.lessons.map((lesson) => ({
                sessionNumber: lesson.session_number,
                completedAt: lesson.session_completed_at,
              }))
            : [],
      }))
    : []
}

export function bonusInfoMapper(info) {
  return {
    hasBonus: info.has_bonus,
    completed: info.completed,
    accuracyRate: info.accuracy_rate,
  }
}
